import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import AvvisoVersione from './AvvisoVersione';
import RisposteSegnalazioni from './RisposteSegnalazioni';

export default function Layout() {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar />
      {/* L'avviso sta sopra il contenuto e non sopra la sidebar: deve
          restringere l'area di lavoro, non coprirla. */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <AvvisoVersione />
        <RisposteSegnalazioni />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
